import { SlotOpsTimeSettings } from '../../Model/SlotOpsTimeSettings';
import { AccountRepository } from '../Repositories/AccountRepository';

export class GetSlotOpsTimeSettingsUseCase {
  constructor(private repo: AccountRepository) {}

  execute(): Promise<SlotOpsTimeSettings> {
    return this.repo.getSlotOpsTimeSettings();
  }
}
